import { FilterLayoutProperties } from '@/types/api/product';

// TODO: Should be moved to the BE: https://bijenkorf.atlassian.net/browse/WD-53609
export const isValidPriceFilter = (layoutProperties: FilterLayoutProperties) =>
  !(
    layoutProperties.slider &&
    !layoutProperties?.validRangeMax &&
    !layoutProperties?.validRangeMin
  );
